import { getStore } from 'owa-protection-store/lib/store/protectionStore';
import type { MailboxInfo } from 'owa-client-types';
import type CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';

export function getCLPLabel(labelId: string, mailboxInfo: MailboxInfo): CLPLabel[] {
    const protectionStore = getStore(mailboxInfo);
    const CLPLabelForId = [];
    if (protectionStore.clpLabels) {
        for (let index = 0; index < protectionStore.clpLabels.length; index++) {
            if (protectionStore.clpLabels[index].id === labelId) {
                CLPLabelForId.push(protectionStore.clpLabels[index]);
                break;
            }
            for (
                let childIndex = 0;
                childIndex < protectionStore.clpLabels[index].children.length;
                childIndex++
            ) {
                if (protectionStore.clpLabels[index].children[childIndex].id === labelId) {
                    CLPLabelForId.push(
                        protectionStore.clpLabels[index],
                        protectionStore.clpLabels[index].children[childIndex]
                    );
                }
            }
        }
    }
    return CLPLabelForId;
}
